import styled from 'styled-components';

import { VerticalCenterBlock } from '../../../../styled';

export const AlertIconWrapper = styled.div`
  margin-bottom: 24px;
`;

export const ModalWrapper = styled.div`
  padding-top: 32px;
  margin-bottom: 32px;
  text-align: center;
`;

export const BanUserSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  margin-bottom: 20px;
`;

export const NotificationTitle = styled.h3`
  ${(props) => props.theme.typography.button}
  color: ${(props) => props.theme.colors.brand};
  font-weight: 600;
  margin-bottom: 10px;
`;

export const NotificationDescription = styled.p`
  ${(props) => props.theme.typography.descriptionCompact}
  color: ${(props) => props.theme.colors.text};
  font-weight: 400;
`;

// fields styles

export const CheckboxWrapper = styled.div`
  margin-bottom: 32px;
`;

export const DateSeparator = styled(VerticalCenterBlock)`
  margin-right: 12px;
  margin-left: 12px;
  height: 36px;
`;

export const HoursSelectWrapper = styled.div`
  margin-right: 12px;
  div {
    width: auto;
    min-width: auto;
  }
`;
